import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import favicon from '../images/Logo.png';
import Contact from '../elements/Contacto';
import Footer from '../elements/Footer';
import styled from 'styled-components';
import Caja from '../styles/components/box.styles';

const Espacio = styled.div`
    min-height: 100vh;
    background: white;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Contacto = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (  
        <>
            <Helmet>
                <link rel="shortcut icon" href={ favicon } type="image/x-icon" data-react-helmet="true"/>
            </Helmet>
            <Caja>
                <Espacio>
                    <Contact/>
                </Espacio>
                <Footer/>
            </Caja>
        </>
    );
}
 
export default Contacto;